import { Component, input, computed } from '@angular/core';
import { ChangeDetectionStrategy } from '@angular/core';

/**
 * Componente reutilizable para tarjetas
 * Reemplaza el patrón repetitivo: card bg-base-100 shadow-lg border border-base-300/50
 */
@Component({
  selector: 'app-card',
  standalone: true,
  imports: [],
  templateUrl: './card.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CardComponent {
  /**
   * Variante de estilo de la tarjeta
   * - 'default': Sin sombra ni borde
   * - 'shadow': Con sombra
   * - 'bordered': Con borde
   * - 'shadow-bordered': Con sombra y borde (más común)
   */
  variant = input<'default' | 'shadow' | 'bordered' | 'shadow-bordered'>('shadow-bordered');

  /**
   * Padding del body
   * - 'sm': p-3 (12px)
   * - 'md': p-5 (20px) - default
   * - 'lg': p-6 (24px)
   * - 'none': Sin padding
   */
  bodyPadding = input<'sm' | 'md' | 'lg' | 'none'>('md');

  /**
   * Si la tarjeta debe tener efecto hover
   */
  hover = input<boolean>(false);

  /**
   * Si la tarjeta debe ser clickeable (agrega cursor-pointer)
   */
  clickable = input<boolean>(false);

  /**
   * Clases adicionales para la tarjeta
   */
  additionalClasses = input<string>('');

  protected cardClasses = computed(() => {
    const base = 'card bg-base-100';
    
    const variantClasses: Record<string, string> = {
      'default': '',
      'shadow': 'shadow-lg',
      'bordered': 'border border-base-300/50',
      'shadow-bordered': 'shadow-lg border border-base-300/50'
    };

    const hoverClass = this.hover() ? 'transition-all duration-200 hover:shadow-xl' : '';
    const clickableClass = this.clickable() ? 'cursor-pointer' : '';

    return [
      base,
      variantClasses[this.variant()],
      hoverClass,
      clickableClass,
      this.additionalClasses()
    ].filter(Boolean).join(' ');
  });

  protected bodyClasses = computed(() => {
    const paddingClasses: Record<string, string> = {
      'sm': 'p-3',
      'md': 'p-5',
      'lg': 'p-6',
      'none': ''
    };
    
    return paddingClasses[this.bodyPadding()];
  });
}
